import * as React from 'react';

import { TableGroupRowContainer, TableRowContainer } from '../Row';
import { IProp } from '../../../../types/redux/props';
import { EFieldName } from '../../../../types/field';

export interface ITableGroupContainerProps extends IProp {
  dragging?: boolean;
  position: number;
  contactsRowRef?: React.Ref<HTMLTableRowElement>;
}

export const TableGroupContainer = ({
  name,
  text,
  items,
  position,
  dragging,
  contactsRowRef,
}: ITableGroupContainerProps): React.JSX.Element => {
  return (
    <>
      <TableGroupRowContainer name={name} key={name + text} title={text} />
      {items.map(({ name: filedName, text: fieldTitle }) => (
        <TableRowContainer
          rowRef={filedName === EFieldName.Contacts ? contactsRowRef : undefined}
          key={filedName + fieldTitle}
          groupName={name}
          name={filedName}
          title={fieldTitle}
          position={position}
          dragging={dragging}
        />
      ))}
    </>
  );
};
